import { render, staticRenderFns } from "./MTNBusiness.vue?vue&type=template&id=8b0ea9dc&"
import script from "./MTNBusiness.vue?vue&type=script&lang=js&"
export * from "./MTNBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports